import { render, staticRenderFns } from "./SystemAndManagement.vue?vue&type=template&id=17b8bd1a&lang=html"
import script from "./SystemAndManagement.vue?vue&type=script&lang=js"
export * from "./SystemAndManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/global.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports